import { BrowserRouter, Routes, Route } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from './components/ErrorBoundary';
import CartPage from './routes/cart/CartPage';
import ThanksPage from './routes/thanks/ThanksPage';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/checkout">
          <Routes>
            {/* Cart/Checkout Route */}
            <Route path="/purchase/cart/:productId" element={<CartPage />} />

            {/* Thanks/Confirmation Route */}
            <Route path="/purchase/thanks" element={<ThanksPage />} />

            {/* Default redirect - use window.location for cross-origin */}
            <Route path="/" element={<RedirectToHome />} />

            {/* Catch-all redirect */}
            <Route path="*" element={<RedirectToHome />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

// Component to handle cross-origin redirect
function RedirectToHome() {
  window.location.href = 'https://www.pdf2xl.com';
  return null;
}

export default App;
